import { get, post } from "./apiHelper";
import { formatFileUrlValue } from "../utils/Formatter";

const ATTACHMENTS_ENDPOINT = "api/v1/organisation/attachments";

const normalizeTransactionCode = (tranCode) =>
  String(tranCode || "")
    .trim()
    .toLowerCase();

export const fetchAttachments = ({ tranCode, scope, parentId, fieldName }) => {
  const query = new URLSearchParams({
    tran_code: normalizeTransactionCode(tranCode),
    scope,
    parent_id: String(parentId),
  });

  if (fieldName) {
    query.set("field_name", fieldName);
  }

  return get(`${ATTACHMENTS_ENDPOINT}?${query.toString()}`);
};

// Item attachments are stored per transaction, so match them to a line via the row's saved field value.
export const filterAttachmentsForRowValue = (attachments, rowValue) => {
  const value = String(rowValue ?? "").trim();
  if (!value || !Array.isArray(attachments)) return [];
  return attachments.filter((attachment) =>
    [
      attachment.url,
      attachment.file_url,
      attachment.s3_url,
      attachment.file_name,
      attachment.name,
    ].some((candidate) => candidate && value.includes(String(candidate))),
  );
};

export const populateDrawingFileNames = async (rows, headings, tranCode) => {
  const drawingFields = headings.filter((heading) =>
    /drawing|dwg/i.test(`${heading.field_name} ${heading.display_name || ""}`),
  );
  if (!drawingFields.length) return rows;

  return Promise.all(
    rows.map(async (row) => {
      if (!row.tran_id) return row;
      try {
        const response = await fetchAttachments({
          tranCode,
          scope: "head",
          parentId: row.tran_id,
        });
        const attachments = Array.isArray(response)
          ? response
          : response?.attachments || response?.items || response?.data || [];
        const updatedRow = { ...row };
        const normalizeField = (field) =>
          String(field || "")
            .toLowerCase()
            .replace(/[^a-z0-9]/g, "");

        drawingFields.forEach((heading) => {
          const fileNames = attachments
            .filter(
              (attachment) =>
                normalizeField(attachment.field_name) ===
                normalizeField(heading.field_name),
            )
            .map((attachment) =>
              formatFileUrlValue(
                attachment.file_name ||
                  attachment.name ||
                  attachment.file_url ||
                  attachment.url,
              ),
            )
            .filter(Boolean);
          if (fileNames.length) {
            updatedRow[heading.field_name] = fileNames.join(", ");
          }
        });
        return updatedRow;
      } catch (_) {
        return row;
      }
    }),
  );
};

export const adoptAttachments = ({
  attachmentIds,
  tranCode,
  scope,
  parentId,
}) =>
  post(`${ATTACHMENTS_ENDPOINT}/adopt`, {
    attachment_ids: attachmentIds,
    tran_code: normalizeTransactionCode(tranCode),
    scope,
    parent_id: parentId,
  });

export const deleteAttachment = (attachmentId) =>
  post(`${ATTACHMENTS_ENDPOINT}/delete/${attachmentId}`);
